const buttonConfirmTenant = {
  text: 'Agregar acceso'
};

export default buttonConfirmTenant;
